import { Button, ButtonGroup, Content, Dialog, Divider, Flex, Heading, Text, View } from '@adobe/react-spectrum';
import React, { useMemo } from 'react';

// Monorepo shared components
import { useStaticData } from '@exchange-frontends/custom-hooks';
import { getProductNames } from '@exchange-frontends/utils';

/**
 * @param {Object} props
 * @param {() => void} props.close
 * @param {() => void} props.onAccept
 * @param {Object} props.detailScreen
 */
const RequiredProductsDialog = (props) => {
  const { close, onAccept, detailScreen } = props;
  const { hostApps, optionalProducts, appType } = detailScreen || {};
  const productLocs = useStaticData('hostApps');
  const mappedRequiredProducts = useMemo(() => getProductNames(hostApps, productLocs), [hostApps, productLocs]);
  const mappedOptionalProducts = useMemo(
    () => getProductNames(optionalProducts, productLocs),
    [optionalProducts, productLocs]
  );

  return (
    <Dialog>
      <Heading>This application requires additional product(s)</Heading>
      <Divider />
      <Content>
        <Flex direction="column" gap="size-200">
          <Text>
            Your organization should have the following product(s) that the publisher selected as required for this
            application.{appType === 'ABD' && ' Also ensure that you have an App Builder SKU.'}
          </Text>
          {mappedRequiredProducts?.length > 0 && (
            <View backgroundColor="static-white" padding="size-250">
              <strong>{mappedRequiredProducts.join(', ')}</strong>
            </View>
          )}
          {mappedOptionalProducts?.length > 0 && appType === 'S2S' && (
            <>
              <Text>
                The below Adobe products are also supported by this application, but it doesn&apos;t require them to
                work.
              </Text>
              <View backgroundColor="static-white" padding="size-250">
                <strong>{mappedOptionalProducts.join(', ')}</strong>
              </View>
            </>
          )}
          <Text>Do you still want to proceed{appType !== 'S2S' && ' with your purchase'}?</Text>
        </Flex>
      </Content>
      <ButtonGroup>
        <Button variant="secondary" onPress={close}>
          No, return to browsing
        </Button>
        <Button variant="cta" onPress={onAccept}>
          Yes, continue
        </Button>
      </ButtonGroup>
    </Dialog>
  );
};

export default RequiredProductsDialog;
